import { IAppState, IAction } from '../context/Context'
import { Views } from '../../enums'
import { TCF } from '../../../../cmp/tcf/TCF'
import { GOOGLE_VENDOR_ID } from '../../../constants/gdprVendors'
import { bodyScroll } from '../../../helpers/scroll'
import { AC } from '../../../ac/AC'

export namespace Accept {
  export const reducer = (prevState: IAppState): IAppState => {
    const { customPurposes } = window.$mediavine.web.model
    AC.setAll()
    /**
     * IAB's TCModel.setAll only sets items pertaining to the GVL and vendors,
     * not the publisher. We'll need to separately set publisherConsents,
     * publisherLegitimateInterests, and any available publisherCustomConsents
     */
    TCF.tcModel.setAll()
    TCF.tcModel.purposeConsents.forEach((hasConsent, purposeId) => {
      hasConsent && TCF.tcModel.publisherConsents.set(purposeId)
    })
    TCF.tcModel.purposeLegitimateInterests.forEach((hasConsent, purposeId) => {
      // Purpose 1 does not have legitimate interest; don't set it
      hasConsent && purposeId > 1 && TCF.tcModel.publisherLegitimateInterests.set(purposeId)
    })
    customPurposes && customPurposes.forEach((customPurpose) => {      
      TCF.tcModel.publisherCustomConsents.set(customPurpose.id)
    })
    TCF.consentDoesApply({ displayUi: false })
    TCF.setCookie()
    // We're closing the modal, allow the body to scroll
    bodyScroll(true)
    // Track Google consent and legitimate interest status in NR upon modal close
    const googleConsent: boolean = TCF.tcModel.vendorConsents.has(
      GOOGLE_VENDOR_ID
    )
    const googleLegitimateInterests: boolean = TCF.tcModel.vendorLegitimateInterests.has(
      GOOGLE_VENDOR_ID
    )
    window.$mediavine.newrelic.addPageAction('gdprModal', { googleConsent })
    window.$mediavine.newrelic.addPageAction('gdprModal', {
      googleLegitimateInterests
    })
    return {
      ...prevState,
      view: null
    }
  }
}
